import { memo } from 'react'
import { RaContainer, RaIcon, RaTypography } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'
import { ICONS } from '@constants/icons.constants'
import clsx from 'clsx'

import type { AcfIconBlockIcon, AcfIconBlockProps } from '@typings'

import styles from './acf-icon-block.module.scss'

export const AcfIconBlock = memo(({ icons }: AcfIconBlockProps) => {
  return (
    <RaContainer>
      <ul className={styles['acf-icon-block__list']}>
        {Loop(icons, ({ icon, title }: AcfIconBlockIcon, i: number) => {
          const isLast = i === icons.length - 1
          const isEven = i % 2 === 0
          const puzzleIndex = icon.replace('number-', '')

          return (
            <li
              key={i}
              className={styles['acf-icon-block__list-item']}>
              <div className={styles['acf-icon-block__content']}>
                <div className={styles['acf-icon-block__content__icon']}>
                  <RaIcon
                    color="primary"
                    icon={ICONS[`PUZZLE_NUMBER_${puzzleIndex}`]}
                  />
                </div>
                <RaTypography component="span">{title}</RaTypography>
              </div>
              {!isLast && (
                <div
                  className={clsx(
                    styles['acf-icon-block__arrow'],
                    !isEven && styles['acf-icon-block__arrow--odd']
                  )}>
                  <RaIcon icon={ICONS.BLOCK_LINK} />
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </RaContainer>
  )
})
